import { ownTaskFilter, subscriptionTaskFilter, unknownTaskFilter } from "./utils";
export class BufferedEngine {
    constructor() {
        this.tasks = [];
        this.subscriptions = [];
        this.processing = false;
    }
    queue(task) {
        if (task.done) {
            return;
        }
        this.tasks.push(task);
    }
    subscribe(engine) {
        if (this.subscriptions.indexOf(engine) == -1) {
            this.subscriptions.push(engine);
            return true;
        }
        return false;
    }
    unsubscribe(engine) {
        this.subscriptions = this.subscriptions.filter(sub => sub != engine);
    }
    effect(fn, arg, target) {
        return { fn, arg, target, engine: this };
    }
    flush() {
        this.processing = true;
        let tasks = this.tasks;
        this.tasks = [];
        tasks
            .filter(ownTaskFilter(this))
            .filter(subscriptionTaskFilter(this.subscriptions))
            .filter(unknownTaskFilter(this.subscriptions));
        if (this.tasks.length > 0) {
            this.flush();
        }
        this.processing = false;
    }
    get isProcessing() {
        return this.processing;
    }
}
